function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenBayPackersLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 314 208",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-70,-36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03959,2.22462e-21,2.22462e-21,1.03958,70.0449,37.4673)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 151,
    cy: 98.75,
    rx: 145.25,
    ry: 94.75,
    style: {
      fill: "#203731",
      strokeWidth: "5.77px",
      stroke: "#FFB612"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.062,117.151L127.062,117.151L127.062,94.288L279.263,94.288C279.263,95.588 279.636,96.3 279.651,97.6C280.226,148.726 212.349,179.137 153.5,179.137C77.809,179.137 20.3,144.099 20.599,98.9C20.886,55.326 84.292,18.597 152.486,18.8C207.649,18.8 255.088,43.475 273.063,73.775L215.563,73.775C203.792,58.297 181.18,44.313 149.799,44.313C103.212,44.313 72.974,69.367 72.974,96.2C72.974,126 101.4,147.638 147.2,147.638C181.201,147.638 201.746,134.465 215.062,117.151Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBayPackersLogo);
export default __webpack_public_path__ + "static/media/green-bay-packers-logo.fcfd68010e0bf69fe25bcf33dfdc0102.svg";
export { ForwardRef as ReactComponent };